import { createActionGroup, createFeature, createReducer, on } from '@ngrx/store';
import {
  GeoIpMode,
  RemoteLogType,
  Location,
  CdnCountry
} from '@vshosting/models'
import { FEATURE_NAME } from './settings-base.constant';
import { SettingsBaseState } from './settings-base.model';
import {
  zefResetState,
  zefActionPayload,
  zefActionFailPayload,
  zefActionSuccessPayload
} from '@vshosting/core';

export const SettingsBaseActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    'load settings': zefActionPayload<void>(),
    'load settings fail': zefActionFailPayload,
    'load settings success': zefActionSuccessPayload<{
      geoIpMode: GeoIpMode[];
      remoteLogType: RemoteLogType[];
      locations: Location[];
      countries: CdnCountry[];
    }>()
  }
});

const initialState = new SettingsBaseState();

export const settingsBaseState = createFeature({
  name: FEATURE_NAME,
  reducer: createReducer(
    initialState,
    on(
      SettingsBaseActions.loadSettingsSuccess,
      (s, { data }): SettingsBaseState => ({
          ...s,
          ...data
        })
    ),
    on(zefResetState, () => initialState)
  )
});
